// extracted by mini-css-extract-plugin
export var numpadContainer = "_o8-1";
export var phoneButton = "_o8-0";